// Het advies van de eigen keuzehulp: dezelfde rekensom als Aiden (uitgelezen 11-10-2026).
//   · elke vraag telt even zwaar: perfect 1 · good 0,5 · neutral 0 · bad −1
//   · een cel die Aiden nooit toonde = bad
//   · een gekozen dieetwens is een harde filter (product moet perfect of good zijn) én telt mee
//   · gelijke stand: de volgorde van `regels.producten`
//   · `regels.vraagGewicht`: per vraag een vermenigvuldiger (doel ×5 sinds 12-10; Aiden = alles ×1)
//   · `alleenBij`: het product doet alleen mee als een van die antwoorden gekozen is (oats ↔ vegetarisch)
// Getest tegen alle gemeten Aiden-paden in themes/scripts/keuzehulp-advies.test.mjs.
(function (root) {
  // `max` = hoeveel er terugkomen; standaard regels.aantal. De zijbalk vraagt de hele ranglijst,
  // zodat hij een product dat in de winkel niet (meer) bestaat kan overslaan.
  function advies(regels, antwoorden, max) {
    var W = regels.gewichten;
    var lijst = [];
    var gekozenSleutels = [];
    regels.vragen.forEach(function (v) {
      var a = antwoorden[v.id];
      [].concat(a == null ? [] : a).forEach(function (id) { gekozenSleutels.push(v.id + ':' + id); });
    });
    regels.producten.forEach(function (p, i) {
      if (p.alleenBij && !p.alleenBij.some(function (s) { return gekozenSleutels.indexOf(s) >= 0; })) return;
      var score = 0;
      var sleutels = {};
      var redenen = {};
      var past = true;
      regels.vragen.forEach(function (v) {
        var a = antwoorden[v.id];
        var gekozen = v.type === 'meer' ? a || [] : a == null ? [] : [a];
        gekozen.forEach(function (id) {
          var optie = v.opties.find(function (o) { return o.id === id; });
          // "Geen voorkeur" weegt niet en filtert niet.
          if (optie && optie.exclusief) return;
          var sleutel = v.id + ':' + id;
          var niveau = p.niveaus[sleutel] || 'bad';
          if (v.type === 'meer' && niveau !== 'perfect' && niveau !== 'good') past = false;
          score += W[niveau] * ((regels.vraagGewicht || {})[v.id] || 1);
          if (niveau === 'perfect') {
            (redenen[v.id] = redenen[v.id] || []).push(p.teksten[sleutel] || (optie ? optie.label : id));
            (sleutels[v.id] = sleutels[v.id] || []).push(sleutel);
          }
        });
      });
      // Aiden toont de redenen in een eigen volgorde, niet in de vraagvolgorde.
      var volgorde = regels.redenVolgorde || regels.vragen.map(function (v) { return v.id; });
      var tekst = [].concat.apply([], volgorde.map(function (id) { return redenen[id] || []; }));
      var sl = [].concat.apply([], volgorde.map(function (id) { return sleutels[id] || []; }));
      if (past) lijst.push({ p: p, i: i, score: score, redenen: tekst, sleutels: sl });
    });
    lijst.sort(function (x, y) { return y.score - x.score || x.i - y.i; });
    return lijst.slice(0, max || regels.aantal || 3).map(function (x) {
      return { sku: x.p.sku, handle: x.p.handle, variant: x.p.variant, maaltijden: x.p.maaltijden, tryout: !!x.p.tryout, redenen: x.redenen, sleutels: x.sleutels, score: x.score };
    });
  }
  if (typeof module === 'object' && module.exports) module.exports = advies;
  else root.smKeuzehulpAdvies = advies;
})(this);
